import { Box } from '@chakra-ui/react';
import { BaseAvatar, BaseTooltip } from '@invara-dev/react-base';
import { agentStatusDisplay } from '../../../features/workflow/displayTypes';
import { agentStatusType, UserType } from '../../../features/workflow/types';

type Props = { isSelected?: boolean; user: UserType; onClick?: (x: UserType) => void };
export const WfAvatar = (props: Props) => {
  const statusDisplay = agentStatusDisplay[props.user?.Status as agentStatusType];
  return (
    <Box
      position={'relative'}
      cursor={props.onClick != undefined ? 'pointer' : undefined}
      display={'inline-block'}
      onClick={() => {
        props.onClick?.(props.user);
      }}>
      <BaseAvatar
        border={props.isSelected ? '2px solid black' : undefined}
        name={props.user.Name}
        size={'xs'}
        color={'white'}
        p={'1.3rem'}
        backgroundColor={props.user.BubbleColor}
      />
      <BaseTooltip content={statusDisplay?.name ?? ''}>
        <Box
          border={'1px solid black'}
          pos={'absolute'}
          bottom={0}
          right={0}
          w={'0.8em'}
          h={'0.8em'}
          borderRadius={'full'}
          bgColor={statusDisplay?.bgColor}
        />
      </BaseTooltip>
    </Box>
  );
};
